// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1B1vY","icon":"SortAdornment_icon__3tb15","up":"SortAdornment_up__1sCez","down":"SortAdornment_down__2dvDK","active":"SortAdornment_active__2bt7N"};